import { render, staticRenderFns } from "./Task.vue?vue&type=template&id=33917e8d&scoped=true"
import script from "./Task.vue?vue&type=script&lang=js"
export * from "./Task.vue?vue&type=script&lang=js"
import style0 from "./Task.vue?vue&type=style&index=0&id=33917e8d&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33917e8d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\web\\medical\\medical-student\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('33917e8d')) {
      api.createRecord('33917e8d', component.options)
    } else {
      api.reload('33917e8d', component.options)
    }
    module.hot.accept("./Task.vue?vue&type=template&id=33917e8d&scoped=true", function () {
      api.rerender('33917e8d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/preScreening/task/Task.vue"
export default component.exports